import React from 'react';
const TheadTableRoles = () => {
  return (
    <thead className="  sticky top-0 z-10   bg-gray-100 text-sm  uppercase  text-gray-700 ">
      <tr>
        <th className="px-1  text-left text-sm font-semibold uppercase">Id</th>
        <th className="px-1  text-right text-sm font-semibold uppercase">Numero de contrato</th>
        <th className="px-1  text-left text-sm font-semibold uppercase">Operación modo</th>
        <th className="px-1  text-right text-sm font-semibold uppercase">Presupuesto</th>
        <th className="px-1  text-left text-sm font-semibold uppercase">Inicio</th>
        <th className="px-1  text-left text-sm font-semibold uppercase">Fin</th>
        <th className="px-1  text-left text-sm font-semibold uppercase">Creación</th>
        <th className="px-1  text-left text-sm font-semibold uppercase">Actualización</th>
        <th className="px-1  text-left text-sm font-semibold uppercase">Estado</th>
        <th className="px-1  text-left text-sm font-semibold uppercase">{''}</th>
      </tr>
    </thead>
  );
};
export default TheadTableRoles;
